export default __webpack_public_path__ + "static/media/lorem1.10e9397e.svg";